/**
 * mmc_game_registry.js
 * Game registration and component mapping system
 */

class MmcGameRegistry {
  constructor() {
    this.games = new Map();
    this.components = new Map();
  }

  /**
   * Register a game
   * @param {Object} manifest - Game manifest
   * @param {React.Component} component - React component
   */
  register_game(manifest, component) {
    if (!manifest.id) {
      throw new Error('Game manifest must have an id');
    }

    this.games.set(manifest.id, manifest);
    this.components.set(manifest.id, component);
  }

  /**
   * Get all registered games
   * @returns {Array} Array of game manifests
   */
  get_games() {
    return Array.from(this.games.values());
  }

  /**
   * Get game by ID
   * @param {string} game_id - Game identifier
   * @returns {Object|null} Game manifest
   */
  get_game(game_id) {
    return this.games.get(game_id) || null;
  }

  /**
   * Get component for game
   * @param {string} game_id - Game identifier
   * @returns {React.Component|null} React component
   */
  get_component(game_id) {
    return this.components.get(game_id) || null;
  }

  has_game(game_id) {
    return this.games.has(game_id);
  }

  clear() {
    this.games.clear();
    this.components.clear();
  }
}

export default MmcGameRegistry;
